<div class="--hold" style="background-color: white;  border: solid 4px #dddddd; padding-bottom:0.15em">
      <div class="inner-menu" tabindex="-1">
          <div class="progressMenu" translate='menu.progress'> </div>
          <div [ngClass]="{'border1':status[i]>=0}" 
               *ngFor="let item of menu; let i=index" style="margin:0 0.2em; padding-left:0.5em;"> 
            
             <div [hidden]="status[i]!=4"  style="cursor: pointer"  tooltip="{{item?item.alt:''}}" 
                  (click)="onClick(i)" (keypress)="keyPress($event, i)" 
                   tabindex="0" >
                  <i class="glyphicon glyphicon-exclamation-sign left-icon-2 optOut" style="vertical-align: top"></i>
                  <div class="inline menu-hover right-text2">{{item?item.name:''}}</div>
             </div>
             
             <div [hidden]="status[i]!=8"    tooltip="{{item?item.alt:''}}" >
                  <i class="glyphicon glyphicon-ok-sign left-icon-2 confirmation" style="vertical-align: top"></i>
                  <div class="inline right-text2" style="color:#777">{{item?item.name:''}}</div>
             </div>

             <div [hidden]="status[i]!=2"    tooltip="{{item?item.alt:''}}" 
                  (click)="onClick(i)" (keypress)="keyPress($event, i)" 
                  style="cursor: pointer" tabindex="0">
                  <i class="glyphicon glyphicon-ok-sign left-icon-2 confirmation" style="vertical-align: top"></i>
                  <div class="inline menu-hover right-text2">{{item?item.name:''}}</div>
             </div>
             
             <div [hidden]="status[i]!=1" tabindex="0"  tooltip="{{item?item.alt:''}}" 
                  (click)="onClick(i)" (keypress)="keyPress($event, i)"  
                  style="cursor: pointer">
                  <div class='inline done_box left-icon' style="vertical-align: top;" 
                    [ngClass]="{'left-icon': i < 10, 'left-icon-10': i >= 10}">
                       {{i}}
                  </div>
                  <div class="inline menu-hover  right-text">{{item?item.name:''}}</div>
            </div>

             <div [hidden]="status[i]!=0" (click)="stay($event)"> 
                  <div class='inline dot_box left-icon' style="vertical-align: top;" 
                    [ngClass]="{'left-icon': i < 10, 'left-icon-10': i >= 10}">
                       {{i}}
                  </div>
                  <div class="inline right-text" [ngClass]="{'next-child-skip': i < 3 && data.isNextChild}">{{item?item.name:''}}</div>
            </div>  
            
          </div>
          <div tabindex="0" (focus)="tabMenu()"></div>
      </div>
</div>
